var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('intro'),_c('popular-bundles'),_c('random-offers'),_c('MtnApps'),_c('special-services'),_c('mtn-app')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }